import React from "react";
import Stepper from "../stepper/Stepper";

/**
 * 상세 화면 최상단 진행상태 — 테이블/섹션 없이 Stepper만 표시
 */
export function DetailProgressStatus({contentId, contentCategory}) {
    if (contentId == null || !contentCategory) {
        return null;
    }

    return (
        <section className="detail-progress-status" aria-label="진행상태">
            <Stepper contentId={contentId} contentCategory={contentCategory} />
        </section>
    );
}
